export function resolveBenefitMigrationEntry(enabled, state) {
    if (!enabled)
        return 'existing';
    if (state.kind !== 'ready')
        return state.kind;
    switch (state.snapshot.phase) {
        case 'unavailable':
            return 'existing';
        case 'acceptance-required':
        case 'address-required':
            return 'acceptance';
        case 'provisioning':
        case 'cards-pending':
            return 'tracking';
        case 'complete':
            return 'emissor';
    }
}
export function canViewLegacyBenefits(snapshot) {
    return (snapshot.phase === 'complete' &&
        Boolean(snapshot.identity.legacyContractId && snapshot.emissorContractId) &&
        snapshot.historyAccess === 'available');
}
export function canCreateBenefitsRecharge(snapshot) {
    return snapshot.phase === 'complete';
}
